import React, { ClipboardEvent } from "react";
import {
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { FastField, FormikProps, useFormikContext } from "formik";
import { Data } from "../store/terminal/types";
import { connect } from "react-redux";
import { get } from "lodash";
import { ConfigPropExtenderHoc } from "./StaticConfigProvider";
import OptionalToolTip from "./toolTip/OptionalToolTip";
import SectionWrapper from "./pageSections/SectionWrapper";
import TextInput from "./formElements/TextInput";

interface TippingProps {
  toolTips?: { terminals?: { options?: Record<string, string> } };
  isUpdateAllowed?: boolean;
}

const Tipping = (props: TippingProps) => {
  const formProps = useFormikContext<FormikProps<Data>>();
  const values = (formProps.values as unknown) as Data;

  const { isUpdateAllowed } = props;
  const { TippingMode } = values.attributes;
  const digitsOnly = /^[0-9]*$/;
  const isTippingDisabled = !TippingMode || TippingMode === "disabled";
  const isTippingByPercentage = TippingMode === "tip_by_percentage";

  const percentage1Tooltip = "Percentage 1";
  const percentage2Tooltip = "Percentage 2";
  const percentage3Tooltip = "Percentage 3";

  const endAdornment = (
    <InputAdornment position="end">
      {isTippingByPercentage ? "%" : "$"}
    </InputAdornment>
  );

  const validateOnPaste = (e: ClipboardEvent) => {
    const copiedText = e.clipboardData.getData("text");
    if (!digitsOnly.test(copiedText)) {
      e.preventDefault();
      return false;
    }
  };

  return (
    <SectionWrapper isChild={true} title="Tipping">
      <Grid container spacing={2} xs={12}>
        <Grid item xs={12} md={3}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="tippingMode">Tipping mode</InputLabel>
            <FastField
              as={Select}
              name="attributes.TippingMode"
              labelId="tippingMode"
              label="Tipping mode"
              variant="outlined"
              disabled={!isUpdateAllowed}
            >
              <MenuItem value="disabled">Disabled</MenuItem>
              <MenuItem value="tip_by_percentage">Percentage</MenuItem>
              <MenuItem value="tip_by_value">Value</MenuItem>
            </FastField>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={3}>
          <OptionalToolTip
            tooltip={get(
              props,
              `toolTips.terminals.options.surcharge.["${percentage1Tooltip}"]`
            )}
          >
            <TextInput
              type="number"
              fieldname="attributes.TipWithPercentagePercentage1"
              InputProps={{ endAdornment }}
              disabled={isTippingDisabled || !isUpdateAllowed}
              key={`TipWithPercentagePercentage1_${TippingMode}`}
              label={isTippingByPercentage ? "Percentage 1" : "Value 1"}
              onPaste={validateOnPaste}
            />
          </OptionalToolTip>
        </Grid>
        <Grid item xs={12} md={3}>
          <OptionalToolTip
            tooltip={get(
              props,
              `toolTips.terminals.options.surcharge.["${percentage2Tooltip}"]`
            )}
          >
            <TextInput
              type="number"
              fieldname="attributes.TipWithPercentagePercentage2"
              InputProps={{ endAdornment }}
              disabled={isTippingDisabled || !isUpdateAllowed}
              key={`TipWithPercentagePercentage2_${TippingMode}`}
              label={isTippingByPercentage ? "Percentage 2" : "Value 2"}
              onPaste={validateOnPaste}
            />
          </OptionalToolTip>
        </Grid>
        <Grid item xs={12} md={3}>
          <OptionalToolTip
            tooltip={get(
              props,
              `toolTips.terminals.options.surcharge.["${percentage3Tooltip}"]`
            )}
          >
            <TextInput
              type="number"
              fieldname="attributes.TipWithPercentagePercentage3"
              InputProps={{ endAdornment }}
              disabled={isTippingDisabled || !isUpdateAllowed}
              key={`TipWithPercentagePercentage3_${TippingMode}`}
              label={isTippingByPercentage ? "Percentage 3" : "Value 3"}
              onPaste={validateOnPaste}
            />
          </OptionalToolTip>
        </Grid>
      </Grid>
    </SectionWrapper>
  );
};

const ConnectedTipping = connect(
  null,
  null,
  (_stateProps, _dispatchProps, ownProps: TippingProps) => {
    return {
      ...ownProps,
    };
  }
)(Tipping);

const ConnectedTippingHoc = (props: TippingProps) => (
  // @ts-ignore
  <ConfigPropExtenderHoc propName="toolTips">
    <ConnectedTipping {...props} />
  </ConfigPropExtenderHoc>
);

export default ConnectedTippingHoc;
